
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.166 7.083H15c.916 0 1.666.75 1.666 1.667v8.333c0 .917-.75 1.667-1.666 1.667H5c-.917 0-1.667-.75-1.667-1.667V8.75c0-.917.75-1.667 1.667-1.667h.833V5.417C5.833 3.117 7.7 1.25 10 1.25s4.166 1.867 4.166 4.167v1.666zM10 2.917a2.497 2.497 0 00-2.5 2.5v1.666h5V5.417c0-1.384-1.117-2.5-2.5-2.5zM5 17.083V8.75h10v8.333H5zm6.666-4.166c0 .916-.75 1.666-1.666 1.666-.917 0-1.667-.75-1.667-1.666 0-.917.75-1.667 1.667-1.667.916 0 1.666.75 1.666 1.667z","fill":"#1D3C6F"}})])
          )
        }
      }
    